<template>
  <v-dialog
    :value="value"
    max-width="500"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title>パーミッショングループの割り当て</v-card-title>

      <v-card-text>
        <div
          v-if="user"
          class="subtitle-1 mb-3"
        >
          対象ユーザー: {{ user.name || user.email }}
        </div>

        <div
          v-for="group in groups"
          :key="group.id"
        >
          <v-checkbox
            v-model="selectedGroupIds"
            :value="group.id"
            :label="group.name"
            dense
            hide-details
            class="mt-1"
          />
        </div>

        <div
          v-if="groups.length === 0"
          class="text--secondary"
        >
          割り当て可能なグループがありません。先にグループを作成してください。
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="close"
        >
          キャンセル
        </v-btn>
        <v-btn
          color="primary"
          :loading="isSaving"
          @click="save"
        >
          保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from '@vue/composition-api'

export default {
  name: 'AssignGroupDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: null,
    },
    groups: {
      type: Array,
      required: true,
    },
    assignedGroupIds: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const selectedGroupIds = ref([])
    const isSaving = ref(false)

    watch(() => props.assignedGroupIds, newVal => {
      selectedGroupIds.value = [...newVal]
    }, { immediate: true })

    const close = () => {
      selectedGroupIds.value = []
      emit('input', false)
    }

    const save = async () => {
      isSaving.value = true
      emit('assign', {
        userId: props.user?.id,
        permissionGroupIds: selectedGroupIds.value,
      })
      isSaving.value = false
      close()
    }

    return {
      selectedGroupIds,
      isSaving,
      close,
      save,
    }
  },
}
</script>
